<template>
  <a-modal
    :title="`分配角色 - ${position.name || ''}`"
    :visible="visible"
    :confirm-loading="saving"
    width="900px"
    @ok="submit"
    @cancel="close"
  >
    <a-alert
      type="info"
      show-icon
      style="margin-bottom: 12px"
      message="勾选该岗位拥有的角色，保存为全量覆盖（用户经岗位获得角色）"
    />
    <a-table
      bordered
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :dataSource="roles"
      :pagination="false"
      :scroll="{ y: 360 }"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectionChange }"
    >
      <template slot="isSysCol" slot-scope="text">
        <a-tag v-if="text === 1" color="red">管理员</a-tag>
        <a-tag v-else color="blue">操作员</a-tag>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { fetchPositionRoles, updatePositionRoles, fetchAuthRoleList } from "@/api/setting/auth";

export default {
  name: "position-role-modal",

  props: {
    visible: { type: Boolean, default: false },
    // 岗位对象
    position: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      saving: false,
      roles: [],
      selectedRowKeys: [],
      columns: [
        { title: "角色名称", dataIndex: "name" },
        { title: "角色编码", dataIndex: "code", width: 180 },
        { title: "类型", dataIndex: "isSys", width: 90, align: "center", scopedSlots: { customRender: "isSysCol" } },
        { title: "描述", dataIndex: "remarks", ellipsis: true },
      ],
    };
  },

  watch: {
    visible(val) {
      if (val) {
        this.load();
      }
    },
  },

  methods: {
    load() {
      this.loading = true;
      // 并行拉取：角色全量列表 + 岗位已绑定角色
      Promise.all([
        fetchAuthRoleList({ pageNum: 1, pageSize: 500 }),
        fetchPositionRoles(this.position.id),
      ])
        .then(([roleRes, boundRes]) => {
          this.roles = (roleRes && Array.isArray(roleRes.list)) ? roleRes.list : [];
          const bound = Array.isArray(boundRes) ? boundRes : [];
          this.selectedRowKeys = bound.map((item) => item.roleId);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onSelectionChange(keys) {
      this.selectedRowKeys = keys;
    },
    submit() {
      this.saving = true;
      updatePositionRoles({
        positionId: this.position.id,
        // 全量覆盖：roleIds为该岗位最终角色集合
        roleIds: this.selectedRowKeys,
      })
        .then(() => {
          this.$message.success("设置成功");
          this.close();
        })
        .catch(() => {})
        .finally(() => {
          this.saving = false;
        });
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
